// tog'a #2506 (2026-09-24): ovozli buyruq 2 daqiqagacha. Brauzer yozuvchisi WAV'ni 44.1/48 kHz da beradi (≈190 KB/s —
// avval ~13 soniyada chegaraga yetardi). Yuborishdan oldin 16 kHz MONO 16-bit ga tushiriladi (≈32 KB/s → 2 daqiqa ≈ 3.8 MB).
// Nutqni tanish uchun 16 kHz yetarli (telefon sifati 8 kHz).

export const VOICE_MAX_SECONDS = 120
const TARGET_RATE = 16000

function wavEncode(samples: Float32Array, rate: number): ArrayBuffer {
  const buf = new ArrayBuffer(44 + samples.length * 2)
  const v = new DataView(buf)
  const str = (o: number, s: string) => { for (let i = 0; i < s.length; i++) v.setUint8(o + i, s.charCodeAt(i)) }
  str(0, "RIFF"); v.setUint32(4, 36 + samples.length * 2, true); str(8, "WAVE")
  str(12, "fmt "); v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true)
  v.setUint32(24, rate, true); v.setUint32(28, rate * 2, true); v.setUint16(32, 2, true); v.setUint16(34, 16, true)
  str(36, "data"); v.setUint32(40, samples.length * 2, true)
  let o = 44
  for (let i = 0; i < samples.length; i++, o += 2) {
    const s = Math.max(-1, Math.min(1, samples[i]))
    v.setInt16(o, s < 0 ? s * 0x8000 : s * 0x7fff, true)
  }
  return buf
}

/** WAV blob → 16 kHz mono WAV blob. Brauzer qo'llamasa — asl blob qaytadi (server chegarasi baribir tekshiradi). */
export async function toSpeechWav(blob: Blob): Promise<Blob> {
  try {
    const AC: any = (window as any).AudioContext || (window as any).webkitAudioContext
    const OAC: any = (window as any).OfflineAudioContext || (window as any).webkitOfflineAudioContext
    if (!AC || !OAC) return blob
    const ctx = new AC()
    const ab: ArrayBuffer = await new Response(blob).arrayBuffer()
    // callback shakli — eski Safari ham qo'llaydi
    const decoded: AudioBuffer = await new Promise((res, rej) => ctx.decodeAudioData(ab, res, rej))
    try { ctx.close?.() } catch {}
    const frames = Math.ceil(decoded.duration * TARGET_RATE)
    const off = new OAC(1, frames, TARGET_RATE)
    const src = off.createBufferSource()
    src.buffer = decoded
    src.connect(off.destination)
    src.start(0)
    const rendered: AudioBuffer = await off.startRendering()
    return new Blob([wavEncode(rendered.getChannelData(0), TARGET_RATE)], { type: "audio/wav" })
  } catch {
    return blob
  }
}

export const blobToBase64 = (blob: Blob) =>
  new Promise<string>((resolve, reject) => {
    const fr = new FileReader()
    fr.onload = () => resolve(String(fr.result).split(",")[1] || "")
    fr.onerror = reject
    fr.readAsDataURL(blob)
  })
